export default "__VITE_ASSET__BMY7VhBo__"